module.exports = __webpack_public_path__ + "img/logo.724a568e.png";